import React from 'react'

// css
import 'assets/style/components/header.scss'

// elements
import Heading from 'components/elements/Heading'
import IconButton from 'components/elements/IconButton'

function Element({ className, title, isShare = false, onClick = () => {}, shareClick = () => {} }) {
  return (
    <header className={`site-header site-header-popup ` + className}>
      <div className="row relative">
        <Heading level="1" className="f-20 f-bold" text={title} />
        <div className="right">
          {isShare && <IconButton size="40" type="share" onClick={shareClick} />}
          <IconButton size="40" type="close" onClick={onClick} />
        </div>
      </div>
    </header>
  )
}

export default Element
